import img201001 from "src/assets/images/kwaii/201001.png";
import img201002 from "src/assets/images/kwaii/201002.png";
import img201003 from "src/assets/images/kwaii/201003.png";
import img201004 from "src/assets/images/kwaii/201004.png";
import img201005 from "src/assets/images/kwaii/201005.png";
import img201006 from "src/assets/images/kwaii/201006.png";
import img201007 from "src/assets/images/kwaii/201007.png";
import img201008 from "src/assets/images/kwaii/201008.png";
import img201009 from "src/assets/images/kwaii/201009.png";
import img201010 from "src/assets/images/kwaii/201010.png";
import img201011 from "src/assets/images/kwaii/201011.png";

export default {
  201001: {
    name: "Snowberry",
    output: [202001],
    description:
      "‌A magical plant that bears magical fruits as white as snow. Its fruit is not only the main feed that the magical creature Cellyfish greatly enjoys, but can also be used to extract the pristine White Dye.",
    img: img201001,
    gen: 0,
  },
  201002: {
    name: "Eboney",
    output: [202002],
    description:
      "‌The fruit of this magical plant can be extracted into the mysterious Black Dye. Rockie and Cloray would thrive on these Eboney fruits everyday.",
    img: img201002,
    gen: 0,
  },
  201003: {
    name: "Heartberry",
    output: [202003],
    description:
      "The fruit of this magical plant is said to resemble a passionate heart, hence the name Heartberry. It can be used to extract the desirable Red Dye, and is the favorite nourishment of Leathare and Clayshelly.",
    img: img201003,
    gen: 0,
  },
  201004: {
    name: "Silverey",
    output: [202004],
    description:
      "A magical plant that bears fruits with marvelous silver shine. Its fruit is the source to extract Grey Dye, and is the favorite food for Metalfox and Rockie.",
    img: img201004,
    gen: 0,
  },
  201005: {
    name: "Floral biscuit",
    output: [202005],
    description:
      "‌The fruit of this magical plant bears a resemblance to a flower-shaped biscuit. It is the favorite food source of shy Clayshelly and Woodie, and can be extracted into a bright Orange Dye.",
    img: img201005,
    gen: 0,
  },
  201006: {
    name: "Goldberry",
    output: [202006],
    description:
      "A magical plant that bears fruits with the color of gold. Its fruit can be extracted into Yellow Dye. The Goldberry fruits can be favorite feeds of Plasto and Cellyfish, the Magical Creatures. Goldberry lifespan from a sapling to full-grown state to harvest fruit and feed creatures can be seen from below illustration.",
    img: img201006,
    gen: 0,
  },
  201007: {
    name: "Greenoo",
    output: [202007],
    description:
      "‌The Greenoo fruit is the main source for Green Dye. Cloray and Hedglass are the two Magical Creatures that always crave Greenoo fruits.",
    img: img201007,
    gen: 0,
  },
  201008: {
    name: "Skyberry",
    output: [202008],
    description:
      "A magical plant that bears fruits with the color of the marvelous blue sky. Its fruit is the sole source to extract Blue Dye, and is used to feed two Kawaii Magical Creatures: Hedglass and Plasto.",
    img: img201008,
    gen: 0,
  },
  201009: {
    name: "Brownberry",
    output: [202009],
    description:
      "The fruit of this magical plant can be used to extract Brown Dye, an earthy color, and is a reliable source of food for the two magical creatures: Woodie and Leathare.",
    img: img201009,
    gen: 0,
  },
  201010: {
    name: "Parple",
    output: [202010],
    description:
      "The fruit of this magical plant looks like a quirky purple apple. It is the source to extract the mysterious Purple Dye, and also the food extremely favored by Rubbie and Metalfox.",
    img: img201010,
    gen: 0,
  },
  201011: {
    name: "Pinkberry",
    output: [202011],
    description:
      "The fruit of this magical plant is said to resemble a pinkish pear. It can be used to extract the lovely Pink Dye, the most favorite color among the adorable Kawaii girls, and is also the reliable source of food for our bubbly Rubbie.",
    img: img201011,
    gen: 0,
  },
  201101: {
    name: "Snowberry",
    output: [202001],
    description:
      "‌A magical plant that bears magical fruits as white as snow. Its fruit is not only the main feed that the magical creature Cellyfish greatly enjoys, but can also be used to extract the pristine White Dye.",
    img: img201001,
    gen: 1,
  },
  201102: {
    name: "Eboney",
    output: [202002],
    description:
      "‌The fruit of this magical plant can be extracted into the mysterious Black Dye. Rockie and Cloray would thrive on these Eboney fruits everyday.",
    img: img201002,
    gen: 1,
  },
  201103: {
    name: "Heartberry",
    output: [202003],
    description:
      "The fruit of this magical plant is said to resemble a passionate heart, hence the name Heartberry. It can be used to extract the desirable Red Dye, and is the favorite nourishment of Leathare and Clayshelly.",
    img: img201003,
    gen: 1,
  },
  201104: {
    name: "Silverey",
    output: [202004],
    description:
      "A magical plant that bears fruits with marvelous silver shine. Its fruit is the source to extract Grey Dye, and is the favorite food for Metalfox and Rockie.",
    img: img201004,
    gen: 1,
  },
  201105: {
    name: "Floral biscuit",
    output: [202005],
    description:
      "‌The fruit of this magical plant bears a resemblance to a flower-shaped biscuit. It is the favorite food source of shy Clayshelly and Woodie, and can be extracted into a bright Orange Dye.",
    img: img201005,
    gen: 1,
  },
  201106: {
    name: "Goldberry",
    output: [202006],
    description:
      "A magical plant that bears fruits with the color of gold. Its fruit can be extracted into Yellow Dye. The Goldberry fruits can be favorite feeds of Plasto and Cellyfish, the Magical Creatures. Goldberry lifespan from a sapling to full-grown state to harvest fruit and feed creatures can be seen from below illustration.",
    img: img201006,
    gen: 1,
  },
  201107: {
    name: "Greenoo",
    output: [202007],
    description:
      "‌The Greenoo fruit is the main source for Green Dye. Cloray and Hedglass are the two Magical Creatures that always crave Greenoo fruits.",
    img: img201007,
    gen: 1,
  },
  201108: {
    name: "Skyberry",
    output: [202008],
    description:
      "A magical plant that bears fruits with the color of the marvelous blue sky. Its fruit is the sole source to extract Blue Dye, and is used to feed two Kawaii Magical Creatures: Hedglass and Plasto.",
    img: img201008,
    gen: 1,
  },
  201109: {
    name: "Brownberry",
    output: [202009],
    description:
      "The fruit of this magical plant can be used to extract Brown Dye, an earthy color, and is a reliable source of food for the two magical creatures: Woodie and Leathare.",
    img: img201009,
    gen: 1,
  },
  201110: {
    name: "Parple",
    output: [202010],
    description:
      "The fruit of this magical plant looks like a quirky purple apple. It is the source to extract the mysterious Purple Dye, and also the food extremely favored by Rubbie and Metalfox.",
    img: img201010,
    gen: 1,
  },
  201111: {
    name: "Pinkberry",
    output: [202011],
    description:
      "The fruit of this magical plant is said to resemble a pinkish pear. It can be used to extract the lovely Pink Dye, the most favorite color among the adorable Kawaii girls, and is also the reliable source of food for our bubbly Rubbie.",
    img: img201011,
    gen: 1,
  },
};
